// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FhCW","tabsBox":"styles_tabsBox__1zgcT","createButton":"styles_createButton__MKb04"};